import { IconSizeType } from '@prophecy/icons';

import { Hint, HintPropsType } from '../Misc/Hint';
import { TextProps } from './types';

const levelToIconSizeMap: { [key: string]: IconSizeType } = {
  //Todo: will be replaced with new tokens
  xs: 'xxs',
  sm13: 'xxs',
  sm: 'xs',
  xl: 'xs'
};

export const useHint = ({
  level = 'sm',
  tone,
  hint
}: {
  level?: TextProps['level'];
  tone?: string;
  hint?: HintPropsType;
}) => {
  let _hint: HintPropsType | undefined;
  if (typeof hint === 'string') {
    _hint = { title: hint, overlayStyle: { maxWidth: '350px', maxHeight: '300px', overflow: 'auto' } };
  } else {
    _hint = hint;
  }

  return _hint ? <Hint {..._hint} color={tone} size={levelToIconSizeMap[level]} /> : null;
};
